import React from 'react'

export default function Reviews(props) {
    return (
        <div className='my-2'>
            <hr className='text-secondary' />
        </div>
    )
}